import React, { useState } from "react";

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="w-full relative">
      <div className="container mx-auto px-6 py-4 flex justify-between items-center">
        {/* Logo */}
        <div className="flex items-center">
          <img
            alt="Impulse company logo"
            className="h-10 w-auto"
            src="/LOGO 2.png"
          />
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center space-x-8 font-normal">
          <a
            href="#"
            className="text-slate-600 dark:text-slate-300 hover:text-primary dark:hover:text-primary transition-colors"
          >
            Home
          </a>
          <a
            href="#"
            className="text-slate-600 dark:text-slate-300 hover:text-primary dark:hover:text-primary transition-colors"
          >
            Product Catalog
          </a>

          {/* Contact Button (Dropdown) */}
          <div className="relative">
            <button
              onClick={() => setOpen(!open)}
              className="text-slate-600 dark:text-slate-300 hover:text-primary transition-colors"
            >
              Contact
            </button>

            {open && (
              <div className="absolute right-0 mt-3 w-56 bg-white dark:bg-slate-800 shadow-xl rounded-lg p-4 border border-slate-200 dark:border-slate-700 z-50">
                <p className="text-sm text-slate-700 dark:text-slate-300 mb-2">
                  <strong>Email:</strong><br />
                  <a
                    href="mailto:admin@professionalsupplies.in"
                    className="text-primary"
                  >
                    admin@professionalsupplies.in
                  </a>
                </p>

                <p className="text-sm text-slate-700 dark:text-slate-300 mb-2">
                  <strong>Phone:</strong><br />
                  <a href="tel:+919969556677" className="text-primary">
                    +91 99695 56677
                  </a>
                  <br />
                  <a href="tel:+919969889900" className="text-primary">
                    +91 99698 89900
                  </a>
                </p>
              </div>
            )}
          </div>
        </nav>

        {/* Mobile Menu Button */}
        <button className="md:hidden text-slate-600 dark:text-slate-300">
          <span className="material-icons">menu</span>
        </button>
      </div>
    </header>
  );
};

export default Navbar;
